import { FunctionComponent } from 'react';
import styled from 'styled-components';
import OrganizationDetailsCard, { OrganizationDetailsCardProps } from './OrganizationDetailsCard';
import SupportFeedbackCard from './SupportFeedbackCard';

export type DetailsProps = OrganizationDetailsCardProps;

const Details: FunctionComponent<DetailsProps> = ({ organization }) => (
    <Container>
        <OrganizationDetailsCard organization={organization} />
        <SupportFeedbackCard />
    </Container>
);

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: flex-start;
  gap: 24px;
  width: 100%;
  padding: 24px;
  box-sizing: border-box;
`;

export default Details;
